<template>
  <div>
    <div class="contact-person-atom">
      <div class="contact-person-atom__info">
        <p v-if="contactPerson.name" class="contact-person-atom__info__name">
          {{ contactPerson.name
          }}<span v-if="contactPerson.title"
            ><br />
            <br />{{ contactPerson.title }}</span
          >
        </p>
        <div class="contact-person-atom__info__socials">
          <a v-if="contactPerson.email" :href="contactPerson.email" target="_blank">
            <img src="../../assets/logotypes/social-media/outlook.png" />
          </a>
          <a v-if="contactPerson.linkedIn" :href="contactPerson.linkedIn" target="_blank">
            <img src="../../assets/logotypes/social-media/linkedin.png" />
          </a>
          <a v-if="contactPerson.instagram" :href="contactPerson.instagram" target="_blank">
            <img src="../../assets/logotypes/social-media/instagram.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contactPerson: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.contact-person-atom {
  gap: 8px;
}
.contact-person-atom__info {
  margin-top: 5px;
}
.contact-person-atom__avatar {
  width: 100px;
  margin-top: 30px;
  border-radius: 50%;
  overflow: hidden;
}
p {
  font-family: 'halvfett', sans-serif;
}
.contact-person-atom__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.contact-person-atom__info__name {
  font-family: 'fet', sans-serif;
  letter-spacing: 1px;
  line-height: 12px;
}
.contact-person-atom__info__name span {
  gap: 0px;
}
.contact-person-atom__info__email {
  font-size: 18px;
}
.contact-person-atom__info__socials {
  display: flex;
  margin-top: 10px;
}
.contact-person-atom__info__socials img {
  width: 25px;
  height: 25px;
  margin-right: 15px;
}
.contact-person-atom__info__socials img:hover {
  transform: scale(1.1);
}
</style>
